import { useEffect } from "react";
import { Button, Modal, Form } from "antd";
// import { setLoading } from "../../../store/slices/leads";
// import { useDeleteSourceMutation } from "../../../store/endpoints/sources";

export default function DeleteCustomer({
  selected,
  isVisible,
  setDeleteModal,
}: any) {
  const { source_id, source_name } = selected;
  // const [deleteSource, { isLoading }] = useDeleteSourceMutation(source_id);

  const [form] = Form.useForm();

  useEffect(() => {}, [selected]);

  const onSubmit = async () => {
    // await deleteSource({ source_id });
    setDeleteModal(false);
  };

  const hideModal = async () => {
    setDeleteModal(false);
    // setLoading(false);
  };

  return (
    <Modal
      visible={isVisible}
      title="Delete Customer"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="DeleteSource"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          // loading={isLoading}
          danger
        >
          Delete
        </Button>,
      ]}
    >
      <Form id="DeleteSource" form={form} onFinish={onSubmit}>
        <div>
          <p className="text-center font-bold">
            Are you sure you want to delete this customer
            <span className="text-red-500 ml-1">{source_name}</span>
          </p>
        </div>
      </Form>
    </Modal>
  );
}
